import React from "react";

import BASESvgIcon from '../../../../../../../@BASE/core/BASESvgIcon';

import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";

import moment from "moment";

export const ImageAttribution = ({ attribution, tl, dir }) => {
	return (
		<>
      {attribution.media_url && (
        <Box className='flex justify-center p-16 border-1 mx-16' sx={{ backgroundColor: '#F1F5F9', width: 'calc(100% - 32px)' }}>
          <div className="w-[320px] h-[180px] flex items-center justify-center overflow-hidden">
            <img 
              src={attribution.media_url}
              alt={attribution.title_en}
              className="max-w-full max-h-full object-contain shadow-lg" 
            />
          </div>
        </Box>
      )}
			<Paper elevation={0} variant="outlined" square className="p-16 mx-16 mb-16">
				<Grid container spacing={1}>
					<Grid item xs={12}>
						<Typography className="text-14 font-bold m-0">
							Image Attribution:
						</Typography>
						<Divider className="my-16" />
					</Grid>
					<Grid item container xs={12} spacing={1}>
						<Grid item xs={12} sm={4} lg={2}>
							<Typography className="text-14 font-semibold m-0">
								Title (TL):
							</Typography>
						</Grid>
						<Grid item xs={12} sm={8} lg={10}>
							<Typography className={`${tl} m-0`} dir={dir}>
								{attribution.title_tl}
							</Typography>
						</Grid>		
					</Grid>
					<Grid item container xs={12} spacing={1}>
						<Grid item xs={12} sm={4} lg={2}>
							<Typography className="text-14 font-semibold m-0">
								Title (EN):
							</Typography>
						</Grid>
						<Grid item xs={12} sm={8} lg={10}>
							<Typography className="text-14 m-0">
								{attribution.title_en}
							</Typography>
						</Grid>															
					</Grid>
					<Grid item container xs={12} spacing={1}>
						<Grid item xs={12} sm={4} lg={2}>
							<Typography className="text-14 font-semibold m-0">
								Description:
							</Typography>
						</Grid>
						<Grid item xs={12} sm={8} lg={10}>
							<Typography className="text-14 m-0 wysiwyg" dangerouslySetInnerHTML={{ __html: attribution.description }} />
						</Grid>	
					</Grid>
					<Grid item container xs={12} spacing={1}>
						<Grid item xs={12} sm={4} lg={2}>
							<Typography className="text-14 font-semibold m-0">
								Source URL:
							</Typography>
						</Grid>
						<Grid item xs={12} sm={8} lg={10}>
							<Typography className="text-14 m-0 break-all">
								{attribution.source_url}
							</Typography>
						</Grid>									
					</Grid>
					<Grid item container xs={12} spacing={1}>
						<Grid item xs={12} sm={4} lg={2}>
							<Typography className="text-14 font-semibold m-0">
								Author:
							</Typography>
						</Grid>
						<Grid item xs={12} sm={8} lg={10}>
							<Typography className="text-14 m-0">
								{attribution.author}
							</Typography>
						</Grid>				
					</Grid>
					<Grid item container xs={12} spacing={1}>
						<Grid item xs={12} sm={4} lg={2}>
							<Typography className="text-14 font-semibold m-0">
								Published Date:
							</Typography>
						</Grid>
						<Grid item xs={12} sm={8} lg={10}>
							<Typography className="text-14 m-0">
								{moment.utc(attribution.published_date).local().format('MMM DD, YYYY')}
							</Typography>
						</Grid>						
					</Grid>
					<Grid item container xs={12} spacing={1}>
						<Grid item xs={12} sm={4} lg={2}>
							<Typography className="text-14 font-semibold m-0">
								Downloaded Date:
							</Typography>
						</Grid>
						<Grid item xs={12} sm={8} lg={10}>
							<Typography className="text-14 m-0">
								{moment.utc(attribution.downloaded_date).local().format('MMM DD, YYYY')}
							</Typography>
						</Grid>						
					</Grid>
					<Grid item container xs={12} spacing={1}>
						<Grid item xs={12} sm={4} lg={2}>
							<Typography className="text-14 font-semibold m-0">
								Copyright License:
							</Typography>
						</Grid>
						<Grid item xs={12} sm={8} lg={10}>
							<Typography className="text-14 m-0">
								{attribution.cc_license}
							</Typography>
						</Grid>								
					</Grid>
				</Grid>
			</Paper>			
		</>
	);
};
